import { render, staticRenderFns } from "./Multi.vue?vue&type=template&id=150bf03e&"
import script from "./Multi.vue?vue&type=script&lang=js&"
export * from "./Multi.vue?vue&type=script&lang=js&"
import style0 from "./Multi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports